import { Heart } from 'lucide-react';

const footerLinks = {
  produto: [
    { label: 'Funcionalidades', href: '#funcionalidades' },
    { label: 'Planos', href: '#planos' },
    { label: 'FAQ', href: '#faq' },
  ],
  sobre: [
    { label: 'Sobre nós', href: '#', modal: 'sobre' },
    { label: 'Depoimentos', href: '#depoimentos' },
    { label: 'Contato', href: '#', modal: 'contato' },
  ],
  legal: [
    { label: 'Termos de uso', href: '/termos', modal: 'termos' },
    { label: 'Política de privacidade', href: '/privacidade', modal: 'privacidade' },
    { label: 'Política de cookies', href: '#', modal: 'cookies' },
  ],
};

export default function Footer({ onOpenModal }) {
  const scrollToSection = (e, href) => {
    if (href.startsWith('#') && href !== '#') {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    if (link.modal && onOpenModal) {
      onOpenModal(link.modal);
    } else {
      scrollToSection(e, link.href);
    }
  };

  return (
    <footer data-testid="footer" className="bg-stone-900 text-stone-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <a href="#" className="flex items-center gap-2 mb-4">
              <img
                src="/logo-menoease.svg"
                alt="MenoEase"
                className="h-8 w-auto"
              />
            </a>
            <p className="text-sm text-stone-400 leading-relaxed">
              Seu companheiro digital na jornada da menopausa. Transformando confusão em clareza.
            </p>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleLinkClick(e, link)}
                      className="text-sm text-stone-400 hover:text-[#FAADC7] transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-stone-500">
            &copy; {new Date().getFullYear()} MenoEase. Todos os direitos reservados.
          </p>
          <p className="text-xs text-stone-500 flex items-center gap-1">
            Feito com <Heart size={12} className="text-[#BE5791]" /> para mulheres incríveis
          </p>
        </div>
      </div>
    </footer>
  );
}
